<template lang="html">
  <div class="main-data">
    <div class="box">
      <div class="choose" v-if='projectTrue'>
        <el-select
          v-model="projectId"
          :placeholder="message.Pl138"
          filterable
          :loading="loading1"
          @visible-change="projectList()"
          @change="userId = 1"
          style="height:100%;margin-right: 30px"
        >
          <el-option
            v-for="item in projectOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
            v-show="false"
            v-model="userId"
            :placeholder="message.Pl139"
            filterable
            :loading="loading2"
            @visible-change="userList"
            style="height:100%;margin-right: 30px"
          >
          <el-option
            v-for="item in userOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="dataValue"
          type="daterange"
          :picker-options="pickerOptions"
          :placeholder="message.Pl140"
          align="right"
          style="width:300px;margin-right:30px;"
          @onClick="dateChoose()"
          :format="format"
        >
        </el-date-picker>
        <el-button size="medium" type="primary" @click="onSubmit()">{{message.Fl118}}</el-button>
      </div>
      <div class="chart">
        <div v-if='projectTrue' class="chart-none" style="">
          {{message.Pl141}}
        </div>
        <div v-if="!projectTrue" class="chart-none" style="">
          {{message.Pl142}}
        </div>
        <div id="chart">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import walden from '@/style/walden.json'
export default {
  data () {
    return {
      message: {
        Sl122: this.$lang.ui.system.l122,
        Pl138: this.$lang.ui.prompt.l138,
        Pl139: this.$lang.ui.prompt.l139,
        Pl140: this.$lang.ui.prompt.l140,
        Fl118: this.$lang.ui.form.l118,
        Pl141: this.$lang.ui.prompt.l141,
        Pl142: this.$lang.ui.prompt.l142
      },
      format: ' ',
      loading1: true,
      loading2: true,
      projectTrue: false,
      projectId: '',
      userId: 1,
      dataValue: [],
      trafficData: {
        x: [],
        upload: [],
        download: [],
        total: []
      },
      projectOptions: [],
      userOptions: [],
      pickerOptions: {
        shortcuts: [{
          text: this.$lang.ui.system.date.l13,
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: this.$lang.ui.system.date.l14,
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: this.$lang.ui.system.date.l15,
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  mounted () {
    if (window.attachEvent) {
      window.attachEvent('onresize', this.onWindowResize)
    } else {
      window.addEventListener('resize', this.onWindowResize)
    }
    this.projectList(true, response => {
      this.projectId = 1
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      this.dataValue = [start, end]
      this.onSubmit()
    })
    this.getDateFormat()
  },
  methods: {
    getDateFormat () {
      let format = 'yyyy-MM-dd'
      if (localStorage.dateSet === '1') {
        format = 'yyyy-MM-dd'
      } else if (localStorage.dateSet === '2') {
        format = 'MM-dd-yyyy'
      } else if (localStorage.dateSet === '3') {
        format = 'dd-MM-yyyy'
      }
      this.format = format
    },
    onWindowResize () {
      var myChart = this.chart()
      myChart.resize()
    },
    chart () {
      echarts.registerTheme('walden', walden)
      var myChart = echarts.init(document.getElementById('chart'), 'walden')
      return myChart
    },
    projectList (val, callback) {
      if (val) {
        this.$api.getProjectList(1, response => {
          this.projectOptions = []
          this.loading1 = false
          if (response.projects !== null) {
            this.projectTrue = true
            this.projectOptions.push({
              label: this.$lang.ui.system.l153,
              value: 1
            })
            for (var i = 0; i < response.projects.length; i++) {
              this.projectOptions.push({
                label: response.projects[i].name,
                value: response.projects[i].id
              })
            }
            if (callback) {
              var back = true
              callback(back)
            }
          } else {
            this.projectTrue = false
          }
        })
      }
    },
    userList (val) {
      if (val) {
        this.$api.getUsersList(this.projectId, response => {
          this.userOptions = []
          this.loading2 = false
          this.userOptions.push({
            label: this.$lang.ui.system.l154,
            value: 1
          })
          for (var i = 0; i < response.members.length; i++) {
            this.userOptions.push({
              label: response.members[i].user_info.name,
              value: response.members[i].user_info.id
            })
          }
        })
      }
    },
    onSubmit () {
      if (!this.dataValue || this.projectId === '') {
        return
      }
      if (this.projectId !== 1) {
        if (this.userId === '') {
          return
        }
      }
      var myChart = this.chart()
      myChart.showLoading()
      function dateFormat (inputDate) {
        var date = inputDate
        // console.log(inputDate)
        var Y = date.getFullYear() + '-'
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        var D = date.getDate()
        return Y + M + D
      }
      var startData = dateFormat(this.dataValue[0])
      var endData = dateFormat(this.dataValue[1])
      // console.log(this.dataValue)
      // console.log(endData)
      this.trafficData.x = []
      this.trafficData.upload = []
      this.trafficData.download = []
      this.trafficData.total = []
      if (this.projectId === 1) {
        this.$api.traffic('all', '', startData, endData, response => {
          // console.log(response)
          if (response.cydex_data_list === null) {
            var myChart = this.chart()
            myChart.hideLoading()
            // myChart.setOption({
            //   backgroundColor: 'transparent'
            // })
            myChart.clear()
            return
          }
          for (var i = 0; i < response.cydex_data_list.length; i++) {
            this.trafficData.x.push(response.cydex_data_list[i].dt)
            this.trafficData.upload.push(response.cydex_data_list[i].traffic_up)
            this.trafficData.download.push(response.cydex_data_list[i].traffic_down)
            this.trafficData.total.push(response.cydex_data_list[i].traffic_up + response.cydex_data_list[i].traffic_down)
          }
          this.traffic(response)
        })
      } else {
        if (this.userId === 1) {
          this.$api.traffic('project', this.projectId, startData, endData, response => {
            if (response.cydex_data_list === null) {
              myChart.hideLoading()
              // myChart.setOption({
              //   backgroundColor: 'transparent'
              // })
              myChart.clear()
              return
            }
            for (var i = 0; i < response.cydex_data_list.length; i++) {
              this.trafficData.x.push(response.cydex_data_list[i].dt)
              this.trafficData.upload.push(response.cydex_data_list[i].traffic_up)
              this.trafficData.download.push(response.cydex_data_list[i].traffic_down)
              this.trafficData.total.push(response.cydex_data_list[i].traffic_up + response.cydex_data_list[i].traffic_down)
            }
            this.traffic(response)
          })
        } else {
          this.$api.traffic('user', this.userId, startData, endData, response => {
            var myChart = this.chart()
            myChart.hideLoading()
            myChart.setOption({
              backgroundColor: 'transparent'
            })
            myChart.clear()
          //  this.traffic(response)
          })
        }
      }
    },
    traffic (data) {
      var myChart = this.chart()
      myChart.resize()
      myChart.hideLoading()
      myChart.setOption({
        backgroundColor: '#fff',
        title: {
          'text': this.$lang.ui.system.l155,
          'subtext': ''
          // top: 0,
          // left: 'center',
          // textStyle: {
          //   color: '#fff',
          //   fontSize: '30'
          // },
          // subtextStyle: {
          //   color: '#90979c',
          //   fontSize: '16'
          // }
        },
        tooltip: {
          'trigger': 'axis',
          // 'axisPointer': {
          // 'type': 'shadow',
          //   textStyle: {
          //     color: 'blue'
          //   }
          // }
          formatter: (val) => {
            // console.log(val)
            var dateArray = val[0].axisValue.split('-')
            let x = dateArray[0] + '-' + dateArray[1] + '-' + dateArray[2]
            if (localStorage.dateSet === '1') {
              x = dateArray[0] + '-' + dateArray[1] + '-' + dateArray[2]
            } else if (localStorage.dateSet === '2') {
              x = dateArray[1] + '-' + dateArray[2] + '-' + dateArray[0]
            } else if (localStorage.dateSet === '3') {
              x = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0]
            } else {
              x = dateArray[0] + '-' + dateArray[1] + '-' + dateArray[2]
            }
            var res = `<div class='tooltip'>`
            res += `<div class='time'>${x}</div>`
            res += `<div class='up'>${val[0].seriesName + ' : ' + this._global.trafficSwitch(val[0].value)}</div>`
            res += `<div class='down'>${val[1].seriesName + ' : ' + this._global.trafficSwitch(val[1].value)}</div>`
            res += `</div>`
            return res
          }
        },
        toolbox: {
          feature: {
            magicType: { show: true, type: ['line'], title: { line: this.$lang.ui.system.l212 } },
            restore: { show: true, title: this.$lang.ui.system.l213 }
            // saveAsImage: {show: true, title: this.$lang.ui.system.l214}
          },
          right: 32
        },
        grid: {
          'borderWidth': 0,
          'top': 50,
          'left': 65,
          'right': 85,
          'bottom': 100
        },
        legend: {
          // textStyle: {
          //   color: '#fff'
          // },
          // top: '60px',
          'data': [this.$lang.ui.system.l156, this.$lang.ui.system.l157, this.$lang.ui.system.l158],
          'selected': {
            [this.$lang.ui.system.l158]: false
          }
        },
        calculable: true,
        xAxis: [{
          // 'axisLine': {
          //   lineStyle: {
          //     color: '#31434f',
          //     width: 2
          //   }
          // },
          // 'splitLine': {
          //   'show': false
          // },
          'axisTick': {
            'show': false
          },
          // 'splitArea': {
          //   'show': false
          // },
          'axisLabel': {
            'interval': 0,
            'rotate': -25,
            'margin': 20,
            formatter: function (value, index) {
              var dateArray = value.split('-')
              let x = dateArray[1] + '-' + dateArray[2]
              if (localStorage.dateSet === '1' || localStorage.dateSet === '2') {
                x = dateArray[1] + '-' + dateArray[2]
              } else if (localStorage.dateSet === '3') {
                x = dateArray[2] + '-' + dateArray[1]
              } else {
                x = dateArray[1] + '-' + dateArray[2]
              }
              return x
            }
          },
          'data': this.trafficData.x
        }],
        yAxis: [{
          'type': 'value',
          // 'splitLine': {
          //   'show': true,
          //   lineStyle: {
          //     color: '#31434f',
          //     width: 2
          //   }
          // },
          // 'axisLine': {
          //   lineStyle: {
          //     color: '#31434f',
          //     width: 2
          //   }
          // },
          // 'axisTick': {
          //   'show': false
          // },
          'axisLabel': {
            formatter: (value, index) => {
              var x = this._global.trafficSwitch(value)
              return x
            }
            // 'interval': 0,
            // textStyle: {
            //   fontSize: 12
            // }
          }
          // 'splitArea': {
          //   'show': false
          // }
        }],
        dataZoom: [{
          'type': 'slider',
          'show': true,
          'height': 30,
          'xAxisIndex': [
            0
          ],
          'bottom': 10,
          'start': 55,
          'end': 100,
          handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
          // handleSize: '110%',
          // handleStyle: {
          //   color: '#1c303f'
          // },
          // textStyle: {
          //   color: '#fff'
          // },
          // borderColor: '#1c303f',
          // dataBackground: {
          //   areaStyle: {
          //     color: '#093c5f',
          //     opacity: 1
          //   }
          // }
          'data': this.trafficData.x,
          labelFormatter: function (val) {
            var dateArr = data.cydex_data_list[val].dt.split('-')
            // console.log(dateArr)
            let x = dateArr[0] + '-' + dateArr[1] + '-' + dateArr[2]
            if (localStorage.dateSet === '1') {
              x = dateArr[0] + '-' + dateArr[1] + '-' + dateArr[2]
            } else if (localStorage.dateSet === '2') {
              x = dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0]
            } else if (localStorage.dateSet === '3') {
              x = dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0]
            } else {
              x = dateArr[0] + '-' + dateArr[1] + '-' + dateArr[2]
            }
            return x
          }
        }],
        series: [{
          'name': this.$lang.ui.system.l156,
          'type': 'bar',
          'stack': '总量',
          // 'barGap': '10%',
          'itemStyle': {
            'normal': {
              // 'color': '#dc4559',
              'label': {
                'show': true,
                // 'textStyle': {
                //   'color': '#fff'
                // },
                'position': 'insideTop',
                formatter: function (p) {
                  return p.value > 0 ? (this._global.trafficSwitch(p.value)) : ''
                }.bind(this)
              }
            }
          },
          'data': this.trafficData.upload
        },
        {
          'name': this.$lang.ui.system.l157,
          'type': 'bar',
          'stack': '总量',
          'itemStyle': {
            'normal': {
              // 'color': '#4ecf93',
              'label': {
                'show': true,
                'position': 'top',
                formatter: function (p) {
                  return p.value > 0 ? (this._global.trafficSwitch(p.value)) : ''
                }.bind(this)
              }
            }
          },
          'data': this.trafficData.download
        },
        {
          'name': this.$lang.ui.system.l158,
          'type': 'line',
          'stack': '总量',
          'itemStyle': {
            'normal': {
              // 'color': '#ffc547',
              'label': {
                'show': true,
                'position': 'top',
                formatter: function (p) {
                  return p.value > 0 ? (this._global.trafficSwitch(p.value)) : ''
                }.bind(this)
              }
            }
          },
          'data': this.trafficData.total
        }]
      })
    }
  },
  beforeDestroy () {
    if (window.detachEvent) {
      window.detachEvent('onresize', this.onWindowResize)
    } else {
      window.removeEventListener('resize', this.onWindowResize)
    }
  }
}
</script>

<style scoped lang="css">
.main-data {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 20px;
  background-color: #fff;
}
.box {
  position: absolute;
  top: 15px;
  height: 100%;
  width: 100%;
}
.choose {
  text-align: left;
  padding: 0 20px;
}
.chart {
  position: absolute;
  overflow: hidden;
  height: auto;
  top: 60px;
  bottom: 20px;
  left: 20px;
  right: 35px;
}
.chart-none {
  position: absolute;
  color: #bfcbd9;
  width: 100%;
  text-align: center;
  top: 30px;
}
#chart {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
